
<script>
    import { onMount } from "svelte";
    import { Authentication } from '../stores'
    import IconAdd from "../icons/IconAdd.svelte";
    import IconTransfers from "../icons/IconTransfers.svelte";
    import CheeseCru from "./CheeseCru.svelte";
    import CheeseTransfers from "./CheeseTransfers.svelte";
    
    let authenthicationData = '';
    let editSelectedLocation;
    let modal;
    let modalTransfers;
    let cheeseInLocationsCnt = '?';
    let cheeseInLocationsReservedCnt = '?';
    let cheeseInLocationsUnReservedCnt = '?';
    
    onMount(async function () {
      loadCheeseData();
    });

    function addCheese() {
        editSelectedLocation = {id: 0, cheeseTypeId: 0, locationId: 0, locationLevel: 0, locationLevelPosition: 0, Remark: '', creationDate: null, creationWeight: 0, soldWeight: 0, price: 0, sold: false};
        modal.show();
    }

    function transferCheese() {
        modalTransfers.show();
    }

    function loadCheeseData() {
        loadCheeseInLocations();
        loadCheeseInLocationsReserved();
        loadCheeseInLocationsUnReserved();
    }

    async function loadCheeseInLocations() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let url = 'MYURL/CheeseCountInLocations';
        
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        cheeseInLocationsCnt = data;
    }

    async function loadCheeseInLocationsReserved() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let url = 'MYURL/CheeseCountInLocationsReserved';
        
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        cheeseInLocationsReservedCnt = data;
    }

    async function loadCheeseInLocationsUnReserved() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let url = 'MYURL/CheeseCountInLocationsUnReserved';
        
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        cheeseInLocationsUnReservedCnt = data;
    }
</script>

<nav>
  <ul>
      <li><h1>Käse</h1></li>
      <li><IconAdd on:clicked={addCheese}/></li>
  </ul>
</nav>

<div class="box">
    <ul class="boxUl">
        <li><h4>Käse im Schrank: {cheeseInLocationsCnt}</h4></li>
        <li><IconTransfers on:clicked={transferCheese}/></li>
    </ul>
</div>
<div class="box">
  <h4>Käse Reserviert: {cheeseInLocationsReservedCnt}</h4>
</div>
<div class="box">
  <h4>Käse Verfügbar: {cheeseInLocationsUnReservedCnt}</h4>
</div>

<CheeseCru bind:this={modal} on:accepted={loadCheeseData}/>
<CheeseTransfers bind:this={modalTransfers}/>

<style>
    h1 {
        margin-left: -30px;
    }

    .box {
      background: lightgray;
      padding: 10px;
      border-radius: 0.8rem;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      height: 56px;
      padding-top: 0px;
    }

    .boxUl {
        margin-left: -40px;
        margin-top: 0px;
    }
    
    ul {
        display: flex;
        justify-content: flex;
        list-style: none;
        align-items: center;
    }

    li {
      display: block;
      margin-right: 1em;
    }

    nav {
        margin-top: -70px;
        margin-bottom: -20px;
    }
</style>